

export const FETCH_RATEADMIN_RATETYPES_LIST = {
    START: 'FETCH_RATEADMIN_RATETYPES_LIST_START',
    SUCCESS: 'FETCH_RATEADMIN_RATETYPES_LIST_SUCCESS',
    ERROR: 'FETCH_RATEADMIN_RATETYPES_LIST_ERROR',
  };
  export const TOAST = {
    RESET: 'RESET_TOAST',
  };
  export const FETCH_RATEADMIN_RATETYPES_INIT="FETCH_RATEADMIN_RATETYPES_INIT"
  export const SET_DELETE_CONFIRMATION_POPUP_VISIBILITY =
  'SET_DELETE_CONFIRMATION_POPUP_VISIBILITY';


  
export const INIT_CREATE_RATEADMIN_RATETYPES_SCREEN =
'INIT_CREATE_RATEADMIN_RATETYPES_SCREEN';

export const CREATE_RATEADMIN_RATETYPES = {
START: 'CREATE_RATEADMIN_RATETYPES_START',
SUCCESS: 'CREATE_RATEADMIN_RATETYPES_SUCCESS',
ERROR: 'CREATE_RATEADMIN_RATETYPES_ERROR',
};

export const EDIT_RATEADMIN_RATETYPES = {
START: 'EDIT_RATEADMIN_RATETYPES_START',
SUCCESS: 'EDIT_RATEADMIN_RATETYPES_SUCCESS',
ERROR: 'EDIT_RATEADMIN_RATETYPES_ERROR',
};

export const FETCH_RATEADMIN_RATETYPES_DETAIL = {
  START: 'FETCH_RATEADMIN_RATETYPES_DETAIL_START',
  SUCCESS: 'FETCH_RATEADMIN_RATETYPES_DETAIL_SUCCESS',
  ERROR: 'FETCH_RATEADMIN_RATETYPES_DETAIL_ERROR',
};
export const EXPORT_RATEADMIN_RATETYPES = {
  START: 'EXPORT_RATEADMIN_RATETYPES_START',
  SUCCESS: 'EXPORT_RATEADMIN_RATETYPES_SUCCESS',
  ERROR: 'EXPORT_RATEADMIN_RATETYPES_ERROR',
};
export const RATEADMIN_RATETYPESDD = {
  START: 'RATEADMIN_RATETYPESDD_START',
  SUCCESS: 'RATEADMIN_RATETYPESDD_SUCCESS',
  ERROR: 'RATEADMIN_RATETYPESDD_ERROR',
};
export const DELETE_RATEADMIN_RATETYPES = {
  START: 'DELETE_RATEADMIN_RATETYPES_START',
  SUCCESS: 'DELETE_RATEADMIN_RATETYPES_SUCCESS',
  ERROR: 'DELETE_RATEADMIN_RATETYPES_ERROR',
};

export const RATEADMIN_RATETYPES_SAVE_TABLE_STATE = 'RATEADMIN_RATETYPES_SAVE_TABLE_STATE';